/**
 * セッションストレージ関係の共通関数
 */

/**
 * セッションストレージの取得
 * @param key セッションストレージのキー
 * @param defaultValue デフォルト値
 * @returns
 */
export function get<T>(key: string, defaultValue: T): T {
  return sessionStorage[key] != null ? (JSON.parse(sessionStorage[key] as string) as T) : defaultValue;
}

/**
 * セッションストレージの設定
 * @param key セッションストレージのキー
 * @param value 値
 */
export function set<T>(key: string, value: T): void {
  sessionStorage[key] = JSON.stringify(value);
}

/**
 * セッションストレージの全削除
 */
export function clear(): void {
  sessionStorage.clear();
}
